import axios from "axios";
import { environment } from "../environments/environment";

export function getModuleOptions (moduleId) {
  return axios.get(`${environment.moduleOptions}?moduleId=${moduleId}`)
}